import { FormItemPropTypes } from '../form-item/default.js'

const FormItemSwitchPropTypes = {
  ...FormItemPropTypes,
}

export default FormItemSwitchPropTypes
